import React from "react";

const HubMembersModal = ({
  isOpen,
  onClose,
  members = [],
  group,
  liveAvatars = {},
  memberAvatarMap = {},
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl w-full max-w-md max-h-[70vh] flex flex-col overflow-hidden shadow-2xl border border-gray-100 animate-in zoom-in-95">
        <div className="p-5 border-b border-gray-100 flex justify-between items-center shrink-0">
          <div>
            <h3 className="text-base font-bold text-gray-900">Study Group Members</h3>
            <p className="text-xs text-gray-500">
              {members.length} of {group?.maxMembers || 5} seats occupied
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {members.map((m) => (
            <div
              key={m.userId}
              className="flex items-center justify-between gap-3 p-3 rounded-2xl bg-gray-50/70 border border-gray-100"
            >
              <div className="flex items-center gap-3 min-w-0">
                <img
                  src={
                    liveAvatars[String(m.userId)] ||
                    memberAvatarMap[String(m.userId)] ||
                    m.avatar ||
                    `https://api.dicebear.com/6.x/initials/svg?seed=${encodeURIComponent(
                      `${m.firstName} ${m.lastName}`
                    )}`
                  }
                  alt="Member"
                  className="w-10 h-10 rounded-full bg-white border border-gray-200 object-cover shrink-0 shadow-xs"
                />
                <div className="min-w-0">
                  <p className="text-sm font-bold text-gray-900 truncate">
                    {m.firstName} {m.lastName}
                  </p>
                  <p className="text-xs text-gray-400 truncate">{m.email || "Study buddy"}</p>
                </div>
              </div>
              <div>
                {m.isOwner ? (
                  <span className="text-[10px] bg-amber-50 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-full font-bold uppercase tracking-wider">
                    👑 Admin
                  </span>
                ) : (
                  <span className="text-[10px] bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full font-bold uppercase tracking-wider">
                    Member
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HubMembersModal;
